import { dataTable } from "@/content/privacyPolicy";

export const DataTable = () => (
  <div className="mt-6 overflow-x-auto rounded-2xl border border-sky-100" data-testid="privacy-data-table">
    <table className="w-full min-w-[640px] text-left text-sm">
      <thead className="bg-[#F4F9FD] font-mono text-[11px] uppercase tracking-[0.18em] text-slate-600">
        <tr>
          <th className="px-4 py-3">Category</th>
          <th className="px-4 py-3">Examples</th>
          <th className="px-4 py-3">Purpose</th>
          <th className="px-4 py-3">Linked to you</th>
        </tr>
      </thead>
      <tbody className="divide-y divide-sky-100 text-slate-700">
        {dataTable.map((r) => (
          <tr key={r.cat} className="align-top">
            <td className="px-4 py-3 font-medium text-ink">{r.cat}</td>
            <td className="px-4 py-3">{r.items}</td>
            <td className="px-4 py-3">{r.why}</td>
            <td className="px-4 py-3">{r.linked}</td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>
);

export const PolicySection = ({ s }) => (
  <section id={s.id} className="scroll-mt-24 border-t border-slate-200 py-10" data-testid={`privacy-section-${s.id}`}>
    <h2 className="font-display text-2xl font-semibold tracking-tight text-ink sm:text-[1.7rem]">{s.title}</h2>
    {s.body?.map((p, i) => (
      <p key={i} className="mt-4 text-base leading-relaxed text-slate-600">{p}</p>
    ))}
    {s.table && <DataTable />}
    {s.list && (
      <ul className="mt-4 space-y-3">
        {s.list.map((li, i) => (
          <li key={i} className="flex gap-3 text-base leading-relaxed text-slate-600">
            <span className="mt-[0.6em] h-1.5 w-1.5 shrink-0 rounded-full bg-sky-600" />
            <span>{li}</span>
          </li>
        ))}
      </ul>
    )}
    {s.after && <p className="mt-4 text-base leading-relaxed text-slate-600">{s.after}</p>}
  </section>
);
